import { ImageComponent, toPlaceholderImage } from '@frontend/internal-assets';
import type { ImageAssetProps } from '@frontend/internal-assets';
import optimizedImage from './image-assets/email-marketing.webp';

const thumbHashString = 'tNeBAoA6qGd2iH+HdW8wRwhYdHZ2eHc=';
const placeholderImage = toPlaceholderImage(thumbHashString);

const calculatedAspectRatio = 2.216400911161731;
const originalWidth = 973;

const EmailMarketing = ({ aspectRatio = calculatedAspectRatio, width = originalWidth, ...rest }: ImageAssetProps) => (
  <ImageComponent
    aspectRatio={aspectRatio}
    width={width}
    src={optimizedImage}
    placeholderSrc={placeholderImage}
    {...rest}
  />
);

export default EmailMarketing;
